import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  Nullable,
  UserWithToken,
  WithMeta,
} from '@ygoargentina/sdk/api/api.types';

export type Platform = {
  id: number;
  name: string;
  slug: Nullable<string>;
  description: Nullable<string>;
};

export const listPlatforms = async (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithMeta<Platform>>(
    gql`
      query platforms {
        data: platforms {
          data {
            id
            name
            slug
            description
          }
          meta {
            total
            perPage
            lastPage
          }
        }
      }
    `
  );
